export const CATEGORIES = Array.from({ length: 16 }, (_, i) => `U${i + 6}`);

// Catégorie d'âge belge : saison du 1er août au 31 juillet, U = année de fin de saison - année de naissance.
export const categorieAuto = (iso, now = new Date()) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso ?? "")) return "";
  const finSaison = now.getMonth() >= 7 ? now.getFullYear() + 1 : now.getFullYear();
  const u = finSaison - Number(iso.slice(0, 4));
  return u > 0 ? `U${u}` : "";
};

export const categorieOf = (j) => (j?.staff ? "" : j?.categorie || categorieAuto(j?.date_naissance));

const norm = (s) => (s ?? "").trim().toLowerCase();
export const joueurKey = (nom, prenom) => `${norm(nom)}|${norm(prenom)}`;

// « Prénom NOM (U12) » pour les messages WhatsApp ; la catégorie vient de la fiche j si fournie.
export const nomCat = (x, j = x) => {
  const c = categorieOf(j);
  return `${x.prenom} ${x.nom.toUpperCase()}${c ? ` (${c})` : ""}`;
};

// Anniversaires dans les 7 prochains jours (aujourd'hui compris), triés par date.
export const anniversairesSemaine = (joueurs, now = new Date()) => {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return (joueurs ?? []).flatMap((j) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(j?.date_naissance ?? "")) return [];
    const [y, m, d] = j.date_naissance.split("-").map(Number);
    let next = new Date(today.getFullYear(), m - 1, d);
    if (next < today) next = new Date(today.getFullYear() + 1, m - 1, d);
    const dans = Math.round((next - today) / 86400000);
    return dans <= 6 ? [{ j, date: next, dans, age: next.getFullYear() - y }] : [];
  }).sort((a, b) => a.dans - b.dans);
};
